module.exports = __webpack_public_path__ + "img/cg.f2e458f5.svg";